module.exports = __webpack_public_path__ + "img/5.11184350.png";